import * as Yup from 'yup';

const loginRules = {
    email: Yup.string().required('Campo obrigatório').email('E-mail inválido'),

    password: Yup.string().required('Campo obrigatório'),
};

export default loginRules;
